App.MobileAppPreviewComponent = Em.Component.extend App.RegistrableMixin,
  env: Em.inject.service('environment')

  classNames: 'mobile-app-preview-component'

  skin: null
  organization: null
  url: null

  iframeIsLoading: true

  baseUrl: (->
    previewTemplate = @get('env.mobileAppPreviewUrl')
    organization_id = @get('organization.id')

    previewTemplate.replace('{id}', organization_id)
  ).property(
    'organization.id',
    'env.mobileAppPreviewUrl')

  iframeUrl: (->
    baseUrl = @get('baseUrl')
    skinSid = @get('skin.secure_id')

    iframeUrl = "#{baseUrl}&preview=true"

    iframeUrl
  ).property(
    'baseUrl',
    'skin.secure_id')

  iframeUrlChanged: (->
    @set('iframeIsLoading', true)
  ).observes('iframeUrl')

  postConfig: ->
    iframe = @$('iframe')[0]
    plainConfig = JSON.parse(JSON.stringify(@get('skin.configuration')))
    config = Object.keys(plainConfig).reduce((result, key) ->
      result[key] = plainConfig[key].value
      result
    , {})
    iframe.contentWindow.postMessage(config, @get('iframeUrl'));

  didInsertElement: ->
    @$('iframe').load =>
      @set('iframeIsLoading', false)
      @postConfig()


  refreshIframe: ->
    @set('iframeIsLoading', true)
    iframe = @$('iframe')[0]
    iframe.src = iframe.src

  actions:
    applyConfig: ->
      @postConfig()

    reload: ->
      Em.run.debounce(@, @refreshIframe, 300)
      false